export const BREAKPOINTS = {
  small: 600,
  medium: 900,
};
